"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _lodash = _interopRequireDefault(require("lodash"));

var _objectHash = _interopRequireDefault(require("object-hash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DataUtils = require("recharts/es6/util/DataUtils");

var _styling = require("../../toolkit/styling");

var _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var defaultFormatter = function defaultFormatter(value) {
  return _lodash["default"].isArray(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(" ~ ") : value;
};

var CustomRechartsTooltipContent = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CustomRechartsTooltipContent, _Component);

  var _super = _createSuper(CustomRechartsTooltipContent);

  function CustomRechartsTooltipContent() {
    (0, _classCallCheck2["default"])(this, CustomRechartsTooltipContent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CustomRechartsTooltipContent, [{
    key: "renderContent",
    value: function renderContent() {
      var _this = this;

      var _this$props = this.props,
          rawPayload = _this$props.payload,
          separator = _this$props.separator,
          hasSeparator = _this$props.hasSeparator,
          formatter = _this$props.formatter,
          itemStyle = _this$props.itemStyle,
          itemSorter = _this$props.itemSorter,
          imageFormatter = _this$props.imageFormatter,
          payloadFormatter = _this$props.payloadFormatter;
      var payload = rawPayload ? rawPayload : [];

      if (payloadFormatter) {
        payload = payloadFormatter(payload);
      }

      if (payload && payload.length) {
        var payloads = Array.isArray(itemSorter) ? _lodash["default"].sortBy(payload, itemSorter) : payload;
        var items = payloads.map(function (entry, i) {
          if (entry.type === "none") {
            return null;
          }

          var finalItemStyle = _objectSpread({
            display: "block",
            paddingTop: 4,
            paddingBottom: 4,
            color: entry.color || "#000"
          }, itemStyle);

          var finalFormatter = entry.formatter || formatter || defaultFormatter;
          var name = entry.name,
              value = entry.value;

          if (finalFormatter) {
            var formatted = finalFormatter(value, name, entry, i);

            if (Array.isArray(formatted)) {
              var _formatted = (0, _slicedToArray2["default"])(formatted, 2);

              value = _formatted[0];
              name = _formatted[1];
            } else {
              value = formatted;
            }
          }

          return /*#__PURE__*/_react["default"].createElement("div", {
            className: (0, _styling.css)(_this.styles.liStyle, finalItemStyle),
            key: (0, _objectHash["default"])(entry)
          }, (0, _DataUtils.isNumOrStr)(name) && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("img", {
            src: imageFormatter(name)
          })), (0, _DataUtils.isNumOrStr)(name) && hasSeparator && /*#__PURE__*/_react["default"].createElement("span", null, separator), /*#__PURE__*/_react["default"].createElement("span", {
            className: (0, _DataUtils.isNumOrStr)(name) && imageFormatter(name) && !hasSeparator ? (0, _styling.css)(_this.styles.iconAndText) : ""
          }, value), /*#__PURE__*/_react["default"].createElement("span", null, entry.unit || ""));
        });
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _styling.css)(this.styles.liStyle, this.styles.listStyle)
        }, items);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          wrapperClassName = _this$props2.wrapperClassName,
          contentStyle = _this$props2.contentStyle,
          labelClassName = _this$props2.labelClassName,
          labelStyle = _this$props2.labelStyle,
          label = _this$props2.label,
          labelFormatter = _this$props2.labelFormatter;

      var finalStyle = _objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
      }, contentStyle);

      var finalLabelStyle = _objectSpread({
        margin: 0
      }, labelStyle);

      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
      var finalLabel = hasLabel ? label : "";
      var wrapperCN = (0, _classnames["default"])("recharts-default-tooltip", wrapperClassName);
      var labelCN = (0, _classnames["default"])("recharts-tooltip-label", labelClassName);

      if (hasLabel && labelFormatter && label != undefined) {
        finalLabel = labelFormatter(label);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: wrapperCN,
        style: finalStyle
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: labelCN,
        style: finalLabelStyle
      }, finalLabel), this.renderContent());
    }
  }, {
    key: "styles",
    get: function get() {
      return _aphrodite.StyleSheet.create({
        listStyle: {
          padding: 0,
          margin: 0
        },
        liStyle: {
          display: "flex",
          flexDirection: "column"
        },
        iconAndText: {
          marginLeft: 10
        }
      });
    }
  }]);
  return CustomRechartsTooltipContent;
}(_react.Component), _class3.displayName = "CustomTooltipContent", _class3.propDoc = {
  separator: {
    required: false,
    type: "string",
    description: "separator between label and value"
  },
  wrapperClassName: {
    required: false,
    type: "string",
    description: "wrapper class name"
  },
  labelClassName: {
    required: false,
    type: "string",
    description: "label class name"
  },
  formatter: {
    required: false,
    type: "(value: string | number, name: string | number, entry: any, " + "i: number) => any",
    description: "The formatter function of value in tooltip. If you return" + "an array, the first entry will be the formatted \"value\", " + "and the second entry will be the formatted \"name\""
  },
  contentStyle: {
    required: false,
    type: "any",
    description: "The style of tooltip content which is a dom element."
  },
  itemStyle: {
    required: false,
    type: "any",
    description: "style of default tooltip content item"
  },
  labelStyle: {
    required: false,
    type: "any",
    description: "The style of default tooltip label which is a p element."
  },
  labelFormatter: {
    required: false,
    type: "(label: any) => string | number",
    description: "The formatter function of label in tooltip."
  },
  label: {
    required: false,
    type: "any",
    description: "The label value which is active now, usually calculated" + "internally."
  },
  imageFormatter: {
    required: true,
    type: "(dataKey: string | number) => any",
    description: "display image in legend by displaying icon for datakey"
  },
  payload: {
    required: false,
    type: "ReadonlyArray<any>",
    description: "The source data of the content to be displayed in the" + "tooltip, usually calculated internally."
  },
  itemSorter: {
    required: false,
    type: "(item1: any, item2: any) => number",
    description: "Sort function of payload"
  },
  payloadFormatter: {
    required: false,
    type: "(payload: ReadonlyArray<any>) => ReadonlyArray<any>",
    description: "preprocess payload"
  },
  hasSeparator: {
    required: false,
    type: "boolean",
    description: "indicator whether there is a separator or not"
  }
}, _class3.defaultProps = {
  hasSeparator: true,
  contentStyle: {},
  itemStyle: {},
  labelStyle: {}
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = CustomRechartsTooltipContent;
exports["default"] = _default;